export function numberWithCommas(x) {
    if(Number(x)>0){
        return parseFloat(x).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

    }else{
        return  x
    }
}